import React from 'react';
import Box from '../../Box/Box.js';
import { defaultSxProp } from '../../utils/defaultSxProp.js';
import { includesSystemProps } from '../../utils/includeSystemProps.js';
import { jsx } from 'react/jsx-runtime';

const BoxWithFallback = /*#__PURE__*/React.forwardRef(function BoxWithFallback({
  as: BaseComponent = 'div',
  sx = defaultSxProp,
  ...rest
}, ref) {
  if (sx !== defaultSxProp || includesSystemProps(rest)) {
    return /*#__PURE__*/jsx(Box, {
      ...rest,
      ref: ref,
      as: BaseComponent,
      sx: sx
    });
  }
  return /*#__PURE__*/jsx(BaseComponent, {
    ...rest,
    ref: ref
  });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
});

export { BoxWithFallback };
